import { render, staticRenderFns } from "./ac-collection-table.vue?vue&type=template&id=0bc3e458&"
import script from "./ac-collection-table.vue?vue&type=script&lang=js&"
export * from "./ac-collection-table.vue?vue&type=script&lang=js&"
import style0 from "./ac-collection-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports